exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-muted {\n  margin-top: 20px;\n  text-align: center; }\n\n.backgroundColor {\n  background: #f3f1f1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = main